// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3Belj","infoBtn":"quickbooks_infoBtn__2DULc","formBox":"quickbooks_formBox__1MInC","formFooter":"quickbooks_formFooter__Qxy2e"};